"use strict";
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
Object.defineProperty(exports, "__esModule", { value: true });
var imageQuantizer_1 = require("./imageQuantizer");
exports.AbstractImageQuantizer = imageQuantizer_1.AbstractImageQuantizer;
var nearestColor_1 = require("./nearestColor");
exports.NearestColor = nearestColor_1.NearestColor;
var array_1 = require("./array");
exports.ErrorDiffusionArray = array_1.ErrorDiffusionArray;
exports.ErrorDiffusionArrayKernel = array_1.ErrorDiffusionArrayKernel;
var riemersma_1 = require("./riemersma");
exports.ErrorDiffusionRiemersma = riemersma_1.ErrorDiffusionRiemersma;
//# sourceMappingURL=index.js.map